import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContentfulCloudinaryImage } from '../../../../core/interfaces/Contentful/CloudinaryImage/ContentfulCloudinaryImage';

@Component({
  selector: 'app-contentful-cloudinary-image',
  templateUrl: './contentful-cloudinary-image.component.html',
  standalone: true,
})
export class AppContentfulCloudinaryImageComponent implements OnChanges {
  @Input() cloudinaryImage?: ContentfulCloudinaryImage;
  @Input({ required: true }) mediaType?: string;

  cloudinaryImageUrl?: string;
  cloudinaryImageAlt?: string;
  imageWidth: string = '700';
  doubleImageWidth: string = '1400';
  imageHeight: string = '700';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cloudinaryImage?.currentValue) {
      // If exist a value for the image, we cast it to ContentfulCloudinaryImage.
      // This cast is safe because the @Input() type is ContentfulCloudinaryImage, ensuring that the value passed have the correct structure.
      const image = changes.cloudinaryImage.currentValue as ContentfulCloudinaryImage;
      // TODO: Fix asset not to bring only file url but image dimenssions
      /* const imageWidth = image?.asset?.fields.file.details?.image?.width ?? 700;
      const imageHeight = image?.asset?.fields.file.details?.image?.height.toString() ?? '700'; */
      const imageWidth = 700;
      const imageHeight = '700';
      const imageRenditionWidth = image?.imageRendition?.width;
      const imageRenditionHeight = image?.imageRendition?.height;
      this.imageWidth = imageRenditionWidth ? imageRenditionWidth.toString() : imageWidth.toString();
      this.doubleImageWidth = imageRenditionWidth ? (2 * imageRenditionWidth).toString() : (2 * imageWidth).toString();
      this.imageHeight = imageRenditionHeight ? imageRenditionHeight.toString() : imageHeight;
      this.cloudinaryImageUrl = this.getImageUrl(image);
      this.cloudinaryImageAlt = image?.alternateText ?? '';
      return;
    }

    this.cloudinaryImageUrl = undefined;
    this.cloudinaryImageAlt = '';
  }

  /**
   * Extracts the image URL from a ContentfulCloudinaryImage object
   * @param image ContentfulCloudinaryImage
   */
  private getImageUrl(image: ContentfulCloudinaryImage): string | undefined {
    const imageUrl = image.asset?.fields.file?.url;

    if (!imageUrl || imageUrl.trim() === '') {
      return undefined;
    }

    return imageUrl;
  }
}
